import render from 'dom-serializer';
import {Element} from 'domhandler';
import {escapeRegExp} from 'lodash';

import {
  CleanHtml,
  iSolemnlySwearThisHtmlIsClean,
} from '../../../../../libs/shared/core/src/helpers/typescript/cleanHtml';
import surveyStars from '../../../../assets/images/signatureSurveyStars.png';
import {surveyTemplateVariable} from '../composerConstants';

/*
 * Constants.
 */

export const surveyImgAttribute = 'data-front-survey-id';
const surveyIdTag = 'front-csat-signature-preview';
const surveyImgAltTag = 'Customer satisfaction survey rating input';
const surveyImgStyle = 'vertical-align: middle;';

/*
 * Helpers.
 */

export function replaceSurveyTemplateVariableWithPreview(
  html: CleanHtml,
  hasCsatSurveysFeature: boolean,
): CleanHtml {
  if (!hasCsatSurveysFeature) {
    return html;
  }

  const surveyElement = new Element('img', {
    [surveyImgAttribute]: surveyIdTag,
    alt: surveyImgAltTag,
    style: surveyImgStyle,
    src: surveyStars,
  });
  const surveyHtml = render(surveyElement);

  return iSolemnlySwearThisHtmlIsClean(
    html.replace(new RegExp(escapeRegExp(surveyTemplateVariable), 'g'), surveyHtml),
  );
}

export function replaceSurveyPreviewWithTemplateVariable(
  html: CleanHtml,
  hasCsatSurveysFeature: boolean,
): CleanHtml {
  if (!hasCsatSurveysFeature) {
    return html;
  }

  return iSolemnlySwearThisHtmlIsClean(
    html.replace(
      new RegExp(`<img[^>]+${escapeRegExp(surveyImgAttribute)}="${escapeRegExp(surveyIdTag)}"[^>]*>`, 'g'),
      surveyTemplateVariable,
    ),
  );
}
